// import React, { useEffect, useState } from 'react'
// import axiosInstance from '../../../../http.common';

// const NewOffer = () => {
//     const token = localStorage.getItem("authToken");
//     const [notifications, setNotifications] = useState([]);

//     useEffect(() => {
//         notificationView();
//     }, []);

//     const notificationView = async () => {
//         try {
//             const response = await axiosInstance.get("/notification/notification-view", {
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${token}`,
//                 },
//             });

//             const fetchedData = response?.data?.data;
//             console.log(fetchedData, "fetchedData");

//             if (fetchedData?.length > 0) {
//                 setNotifications(fetchedData);
//             }
//         } catch (error) {
//             console.log(error, "error");
//         }
//     };

//   return (
//     <div className="row">
//       {orders && orders.length > 0 ? (
//         orders.map((order) => (
//           <div className="col-md-6 mt-3"
//           //  key={order.variant_id}
//            >
//             <div className="order-item">
//               <div className="order-image-slider">
//               <img
//                         src={image}
//                         height={200} 
//                         width={300}  
//                         alt={`Variant ${index + 1}`}
//                         className="order-image"
//                       />
//               </div>
//               <div className="order-details">
//               <h3>{order.finalproductName}</h3>
//                 {order?.itemtype=='V' &&
//                 (<> <p>Make: {order.make_name} | Model: {order.model_name}</p>
//                 <p>Color: {order.color_name} | Product Type: {order.product_name}</p>
//                 <p>Sub Product: {order.subproduct_name}</p></>) }
//                                 {order?.itemtype!='V' &&
//                                 (<> <p>Type: {order.itemtypename} | Category: {order.part_category_name}</p>
//                 <p>Color: {order.color_name} </p>
//                 </>) }
//                 <p className="productprice">Price: {order.final_price}</p>
//                 <div className="order-actions">
//                   <button className="order-now" onClick={() => handleOrderNowClick(order)} ref={assignButtonRef}>
//                     Order Now
//                   </button>
//                   <a href={order?.product_brochure}  target='_blank' className="view-voucher">View Brochure</a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))
//       ) 
//       : (
//        <p>No Offers found.</p>
//       )}


     
//     </div>
//   )
// }

// export default NewOffer

import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../http.common';
import "./NewOffer.scss"

const NewOffer = () => {
    const token = localStorage.getItem("authToken");
    const [notifications, setNotifications] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    useEffect(() => {
        notificationView();
    }, []);

    const notificationView = async () => {
        try {
            const response = await axiosInstance.get("/notification/notification-view", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            const fetchedData = response?.data?.data;
            console.log(fetchedData, "fetchedData");

            if (fetchedData?.length > 0) {
                setNotifications(fetchedData);
            }
        } catch (error) {
            console.log(error, "error");
        }
    };

    const downloadImage = (imageUrl, filename = "downloaded_image.jpg") => {
        if (!imageUrl) return;
    
        fetch(imageUrl)
          .then((response) => response.blob())
          .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => console.error("Error downloading image:", error));
    };

    return (
        <>
        <div style={{padding:"20px"}} className='OnboardManagamentContainer'>
        <div className='OnboardManagamentbuttonContainer'>
          <h2>Offer List</h2>
        </div>
    </div>
    <div className='tableWrapper'>
        <div className="row">
        {notifications && notifications.length > 0 ? (
            notifications.map((notification, index) => (
                <div className="col-md-3 mt-3" key={index}>
                    <div className="offer-card">

                        {/* Image */}
                        <div className="offer-image-section">
                            <img
                                src={notification.imagepath}
                                alt={notification.title}
                                className="offer-image"
                                onClick={() => setSelectedImage(notification.imagepath)}
                            />
                        </div>

                        {/* Content */}
                        <div className="offer-body">

                            <h3 className="offer-title">
                                {notification.title}
                            </h3>

                            <p className="offer-description">
                                {notification.notiDescription}
                            </p>

                            {/* Info Box */}
                            <div className="offer-info-box">
                                <div className="offer-info-row">
                                    <span>Start Date</span>
                                    <span>{notification.startDate}</span>
                                </div>

                                <div className="offer-info-row">
                                    <span>End Date</span>
                                    <span>{notification.endDate}</span>
                                </div>
                            </div>

                            {/* Download Button */}
                            <button
                                className="offer-download-btn"
                                onClick={() =>
                                    downloadImage(
                                        notification.imagepath,
                                        `${notification.title}.jpg`
                                    )
                                }
                            >
                                Download Offer
                            </button>

                        </div>
                    </div>
                </div>
            ))
        ) : (
            <p>No Offers found.</p>
        )}

        {/* Custom Modal */}
        {/* {selectedImage && (
            <div className="modal-overlay">
                <div className="modal-contentt">
                    
                    <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>
                    <img style={{ height: "400px" }} src={selectedImage} alt="Enlarged" />
                </div>
            </div>
        )} */}

{selectedImage && (
            <div className="modal-overlay">
                <div className="modal-contentt">
                    {/* Close Button */}
                    <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>

                    {/* Download Button */}
                    <button className="download-btn" onClick={() => downloadImage(selectedImage)}>
                        ⬇️ Download
                    </button>

                    <img 
                    // style={{ height: "400px" , marginTop:"1rem"}}
                     src={selectedImage}
                      alt="Enlarged"
                    />
                </div>
            </div>
        )}
    </div>
    </div>
    </>
    );
};

export default NewOffer;
